import { atom } from 'jotai';
import SoundproofingServices from '../services/SoundproofingServices';
import { SOUNDPROOFING_PAGE_SIZES } from '../constants/soundproofing';

export const SOUNDPROOFING_SIDEBAR_MODES = {
  composition: 'composition',
  results: 'results',
};

/* Composition Start */
const soundproofingLayersAtom = atom(SoundproofingServices.getInitialLayers());
const soundproofingSelectedLayerIdAtom = atom(null);
const soundproofingProductTypesAtom = atom(SoundproofingServices.getDefaultProductTypes());
const soundproofingRangesAtom = atom(SoundproofingServices.getDefaultRanges());
const soundproofingSidebarModeAtom = atom(SOUNDPROOFING_SIDEBAR_MODES.composition);
/* Composition End */

/* Results Start */
const soundproofingIsResultsVisibleAtom = atom(false);
const soundproofingSearchQueryAtom = atom(null); // composition snapshot taken on «Show results»
const soundproofingResultsAtom = atom([]);
const soundproofingResultsTotalAtom = atom(0);
const soundproofingResultsPageAtom = atom(1);
const soundproofingResultsPageSizeAtom = atom(SOUNDPROOFING_PAGE_SIZES[0]);
const soundproofingResultsLoadingAtom = atom(false);
const soundproofingResultsErrorAtom = atom(false);
const soundproofingResultsFiltersAtom = atom(SoundproofingServices.getDefaultResultsFilters());
const soundproofingSelectedResultsIdsAtom = atom([]);
const soundproofingPdfLoadingAtom = atom(false);
/* Results End */

export {
  soundproofingLayersAtom,
  soundproofingSelectedLayerIdAtom,
  soundproofingProductTypesAtom,
  soundproofingRangesAtom,
  soundproofingSidebarModeAtom,
  soundproofingIsResultsVisibleAtom,
  soundproofingSearchQueryAtom,
  soundproofingResultsAtom,
  soundproofingResultsTotalAtom,
  soundproofingResultsPageAtom,
  soundproofingResultsPageSizeAtom,
  soundproofingResultsLoadingAtom,
  soundproofingResultsErrorAtom,
  soundproofingResultsFiltersAtom,
  soundproofingSelectedResultsIdsAtom,
  soundproofingPdfLoadingAtom,
};
